export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5591.f7712e97.jpg";